import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=2a73be1d&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=2a73be1d&lang=scss"

import exportComponent from "D:\\work\\project\\week-alone\\weekly-alone-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a73be1d"]])

export default __exports__